module.exports = __webpack_public_path__ + "static/media/agenda.c411a67e.png";